import './Layout.scss';

import { type FC, lazy, Suspense } from 'react';
import { Outlet, useNavigation } from 'react-router';

import '../i18n';
import * as Core from './core';

import Header from './Header';
import Footer from './Footer';
import DeviceOrientationNotification from './DeviceOrientationNotification';

const CartLink = lazy(() => import('./CartLink'));

export const Layout: FC = () => {
  const navigation = useNavigation();
  const isNavigating = Boolean(navigation.location);

  return (
    <>
      <Core.ScrollToTop />
      <Core.Notifications />
      <Header />
      <main>
        <Suspense fallback={<Core.Loader />}>
          {isNavigating ? <Core.Loader /> : <Outlet />}
        </Suspense>
      </main>
      <Footer />
      <Suspense fallback={null}>
        <CartLink />
      </Suspense>
      <DeviceOrientationNotification />
    </>
  );
};
